//Footer y Header de la página 

//Imports 
import React from 'react';
import {Link} from 'react-router-dom';
import {Layout, Divider, Button, Space, Menu} from 'antd';
import {
    PoweroffOutlined,
    InstagramOutlined,
    FacebookOutlined,
    TwitterOutlined,
    YoutubeOutlined,
    UserOutlined
} from '@ant-design/icons';
import logoSTI from '../img/logoSTI.png';
import logoUChile from '../img/escudo-uchile-horizontal-blanco-fondo-transp.png';

const {Header, Content, Footer} = Layout;
const { SubMenu } = Menu;

var actual_link = window.location.href;
var link_parts = actual_link.split('/');

const TuiLayout = (props) => {
    if(link_parts[link_parts.length-2] == 'remote_form' || link_parts[link_parts.length-3] == 'remote_form'){
        return (
            <Layout className="layout">
                <Header>
                    <Link to='/main' className="linkMain">
                        <img src={logoUChile} alt="logo" align="end" className="uchile"/>
                        <label className="layout"> | SISTEMA DE TUI VISITAS</label>
                    </Link>
                </Header>

                <Content>
                    <div className="site-layout-content">
                        {props.children}
                    </div>
                </Content>

                <Footer>
                    <div className='info-footer'>
                        <div className="informacion-footer">
                            Sitio desarrollado por
                            <img src={logoSTI} className='logoDSTI' alt="DSTI logo"/>
                        </div>

                        <div className="informacion-footer contacto">
                            <h4 className="informacion-footer">CONTACTO</h4>
                            <h4 className="informacion-footer">mesadeayuda@u.uchile.cl</h4>
                            <h4 className="informacion-footer">(56 2) 229780911</h4>
                        </div>
                    </div>
                </Footer>
            </Layout>
        )
    }else{
        return (
            <Layout className="layout">
                <Header>
                    <Link to='/main' className="linkMain">
                        <img src={logoUChile} alt="logo" align="end" className="uchile"/>
                        <label className="layout"> | SISTEMA DE TUI VISITAS</label>
                    </Link>
                    <Menu triggerSubMenuAction="click" theme="light" style={{borderColor: "#2C3D4E",backgroundColor: "#2C3D4E", color: "#FFFFFF", fontSize:"18px"}} mode="horizontal">
                        <SubMenu /* icon={<UserOutlined style={{fontSize:"18px"}}/>} */ title={<div>{window.User.Name+' '+window.User.LastName+' '+window.User.SecondLastName} <UserOutlined style={{fontSize:"18px", marginLeft:"1px"}}/></div>}>
                        <Menu.Item>
                            <Button id="Logout" style={{fontSize:"18px"}} type="link"> <PoweroffOutlined style={{fontSize:"18px"}}/> Cerrar sesión </Button>
                        </Menu.Item>
                        </SubMenu>
                    </Menu>
                </Header>

                <Content>
                    <div className="site-layout-content">
                        {props.children}
                    </div>
                </Content>

                <Footer>
                    <div className='info-footer'>
                        <div className="informacion-footer">
                            Sitio desarrollado por
                            <img src={logoSTI} className='logoDSTI' alt="DSTI logo"/>
                        </div>

                        <div className="informacion-footer contacto">
                            <h4 className="informacion-footer">CONTACTO</h4>
                            <h4 className="informacion-footer">mesadeayuda@u.uchile.cl</h4>
                            <h4 className="informacion-footer">(56 2) 229780911</h4>
                        </div>
                    </div>
                </Footer>
            </Layout>
        )
    }
}

export default TuiLayout;